import { Text } from "../../ui/text";
import { Vector } from "../../ui/vector";
import { useIconItem, type UseIconItemProps } from "./use-icon-item";

export type IconCardProps = UseIconItemProps;

const IconItem = (props: IconCardProps) => {
  const { className, styles, theme, data } = useIconItem(props);
  const { icon, label, description } = data;

  return (
    <div className={styles.base({ className })} data-component-name="icon-item">
      {!!icon && !description && (
        <span className={styles.iconWrapper()}>
          <Vector className={styles.icon()} name={icon} />
        </span>
      )}
      <div className={styles.content()}>
        <Text
          className={styles.label()}
          theme={theme}
          weight="medium"
          size="description"
        >
          {label}
        </Text>
        {!!description && (
          <Text
            className={styles.description()}
            theme={theme}
            size="description"
          >
            {description}
          </Text>
        )}
      </div>
    </div>
  );
};

export default IconItem;
